import $ from 'jquery';

export default class Cookie {
    /**
     * @param $form Cookie information form
     * @param options Additional options
     */
    constructor($form, options = {}) {
        this.options = $.extend(true, {
            classes: {
                accept: 'cookie__accept',
                remind: 'cookie__remind',
                mainCookie: 'obligacjeCookieRodo',
                remindCookie: 'obligacjePostponeCookieRodo',
                hidden: 'cookie--hidden',
                expand: 'cookie__expand',
                expanded: 'cookie--expanded',
            },
        }, options);

        if (!$form) {
            return;
        }

        this.$form = $form;
        this.$accept = this.$form.querySelector('.' + this.options.classes.accept);
        this.$remind = this.$form.querySelector('.' + this.options.classes.remind);
        this.$expand = this.$form.querySelector('.' + this.options.classes.expand);

        this.init();
    }

    init() {
        this.handleToggle(this.$form);

        let cookieRodo = this.getCookie(this.options.classes.mainCookie);
        let postponeCookieRodo = this.getCookie(this.options.classes.remindCookie);

        if (cookieRodo || postponeCookieRodo) {
            this.$form.remove();
        } else {
            this.$form.classList.remove(this.options.classes.hidden);
        }
    }

    acceptCookie() {
        this.setCookie(this.options.classes.mainCookie, '1', 365);
        this.setCookie(this.options.classes.remindCookie, '0', 0);

        this.$form.remove();
    }

    remindCookie() {
        this.setCookie(this.options.classes.remindCookie, '1', 1 / 8);
        this.setCookie(this.options.classes.mainCookie, '0', 0);

        this.$form.remove();
    }

    expandCookie() {
       this.$form.classList.toggle(this.options.classes.expanded);
    }

    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie(cookie) {
        return document.cookie.split(';').some(c => {
            return c.trim().startsWith(cookie + '=');
        });
    }

    handleToggle() {
        const handler = (e) => {
            e.preventDefault();

            if (e.target.classList.contains(this.options.classes.accept)) {
                this.acceptCookie();
            } else if (e.target.classList.contains(this.options.classes.remind)) {
                this.remindCookie();
            } else if (e.target.classList.contains(this.options.classes.expand)) {
                this.expandCookie();
            }
        }

        this.$accept.addEventListener('click', handler);
        this.$remind.addEventListener('click', handler);
        this.$expand.addEventListener('click', handler);
    }
}


// WEBPACK FOOTER //
// ./front/treasurybond/js/common/cookie.js